<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Documents</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Fleet Managers
                            </li>
                            <li class="breadcrumb-item active">Documents
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Fleet Manager's Documents</h4>
                </div>

                <div class="card-body">
                    <table id="recent-user-documents"
                           class="table table-responsive">
                        <thead>
                        <tr>
                            <th>S/N</th>
                            <th>Document Name</th>
                            <th style="width: 10px">Document</th>
                            <th>Status</th>
                            <th>Date Submitted</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-truncate">1</td>
                                <td class="text-truncate">BVN</td>
                                <td class="text-truncate">{{ documents.bvn }}</td>
                                <td class="text-truncate">
                                     <span v-if="documents.bvn" class="badge badge-glow"
                                           :class="documents.document_status.bvn === 'approved' ? 'badge-success'
                                           : (documents.document_status.bvn === 'pending'  ? 'badge-warning': 'badge-danger')">
                                        {{ documents.document_status.bvn }}
                                    </span>
                                </td>
                                <td class="text-truncate">{{ documents.bvn_submitted_at }}</td>
                                <td class="text-truncate">
                                    <a v-if="documents.bvn && documents.document_status.bvn !== 'approved' " href="#"
                                       @click.prevent="documentAction('bvn', documents.fleet_manager_id, 1)">
                                        <i class="feather icon-check"></i> approve
                                    </a>
                                    <span v-if="documents.bvn && documents.document_status.bvn !== 'rejected' && documents.document_status.bvn !== 'approved'">|</span>
                                    <a v-if="documents.bvn && documents.document_status.bvn !== 'rejected'" href="#" @click.prevent="documentAction('bvn', documents.fleet_manager_id, 0)"
                                       class="text-danger">
                                        <i class="feather icon-edit"></i> reject
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-truncate">2</td>
                                <td class="text-truncate">NIN</td>
                                <td class="text-truncate" style="width: 10px">
                                    <a v-if="documents.nin" :href="documents.nin">
                                        <img :src="documents.nin" :alt="'NIN'" style="width: 40px; height: 40px; object-fit: cover; border-radius: 6px;">
                                    </a>
                                </td>
                                <td class="text-truncate">
                                         <span v-if="documents.nin" class="badge badge-glow"
                                               :class="documents.document_status.nin === 'approved' ? 'badge-success'
                                               : (documents.document_status.nin === 'pending'  ? 'badge-warning': 'badge-danger')">
                                            {{ documents.document_status.nin }}
                                        </span>
                                </td>
                                <td class="text-truncate">{{ documents.nin_submitted_at }}</td>
                                <td class="text-truncate">
                                    <a v-if="documents.nin && documents.document_status.nin !== 'approved' " href="#"
                                       @click.prevent="documentAction('nin', documents.fleet_manager_id, 1)">
                                        <i class="feather icon-check"></i> approve
                                    </a>
                                    <span v-if="documents.nin && documents.document_status.nin !== 'rejected' && documents.document_status.nin !== 'approved'">|</span>
                                    <a v-if="documents.nin && documents.document_status.nin !== 'rejected'" href="#" @click.prevent="documentAction('nin', documents.fleet_manager_id, 0)"
                                       class="text-danger">
                                        <i class="feather icon-edit"></i> reject
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-truncate">3</td>
                                <td class="text-truncate">Proof Of Address</td>
                                <td class="text-truncate" style="width: 10px">
                                    <a v-if="documents.proof_of_address" :href="documents.proof_of_address">
                                        <img :src="documents.proof_of_address" :alt="'Proof Of Address'" style="width: 40px; height: 40px; object-fit: cover; border-radius: 6px;">
                                    </a>
                                </td>
                                <td class="text-truncate">
                                         <span v-if="documents.proof_of_address" class="badge badge-glow"
                                               :class="documents.document_status.proof_of_address === 'approved' ? 'badge-success'
                                               : (documents.document_status.proof_of_address === 'pending'  ? 'badge-warning': 'badge-danger')">
                                            {{ documents.document_status.proof_of_address }}
                                        </span>
                                </td>
                                <td class="text-truncate">{{ documents.proof_of_address_submitted_at }}</td>
                                <td class="text-truncate">
                                    <a v-if="documents.proof_of_address && documents.document_status.proof_of_address !== 'approved' " href="#"
                                       @click.prevent="documentAction('proof_of_address', documents.fleet_manager_id, 1)">
                                        <i class="feather icon-check"></i> approve
                                    </a>
                                    <span v-if="documents.proof_of_address && documents.document_status.proof_of_address !== 'rejected' && documents.document_status.proof_of_address !== 'approved'">|</span>
                                    <a v-if="documents.proof_of_address && documents.document_status.proof_of_address !== 'rejected'" href="#" @click.prevent="documentAction('proof_of_address', documents.fleet_manager_id, 0)"
                                       class="text-danger">
                                        <i class="feather icon-edit"></i> reject
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Fleet Manager'},
    props: ['documents'],
    name: "FleetManagerDocumentIndex",
    layout: Layout,

    data: () => ({
        isLoadingFilter: false,
        tableDataLoading: false,
    }),
    created() {
        //
    },
    methods: {
        documentAction(documentType, fleetManager, action) {
            console.log(documentType, fleetManager, action)
            this.$inertia.put(route('admin.fleet_managers.manage-documents', [fleetManager, documentType]),
                {status: action}, {
                    preserveScroll: true,
                    onSuccess: () => {
                        // const agentIndex = this.agent.findIndex(a => agent.id === a.id);
                        // this.agent[agentIndex].status = this.agent[agentIndex].status === 1 ? 0 : 1;
                    }
                });
        },
    }
}
</script>
